import React from 'react';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { store } from 'store';

import AppPrepare from './app';
import { initDayJsPlugins, initLanguagesForThirdPartyLibs } from './index.utils';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

initLanguagesForThirdPartyLibs();
initDayJsPlugins();

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppPrepare />
    </BrowserRouter>
  </Provider>,
);
